import { FC } from 'react';

import { LoginStyled, NameStyled, UserDisplayStyled } from './UserDisplay.styles';

interface Props {
	name: string;
	login: string;
}

export const UserDisplay: FC<Props> = ({ name, login }) => (
	<UserDisplayStyled>
		<NameStyled>{name}</NameStyled>
		<LoginStyled>{login}</LoginStyled>
	</UserDisplayStyled>
);
